import { createContext, PropsWithChildren, useCallback, useContext } from 'react';
import { useLocalStorage } from 'react-use';

import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';

const HelicopterContext = createContext({
	enabled: false,
	enable: () => {},
	disable: () => {},
});

// eslint-disable-next-line @typescript-eslint/ban-types
export default function HelicopterProvider(props: PropsWithChildren<{}>) {
	const [enabled, setEnabled] = useLocalStorage('helicopterEnabled', false);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const enable = useCallback(() => setEnabled(true), []);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const disable = useCallback(() => setEnabled(false), []);

	const { isWorkspaceSuperuser, isManager } = useViewerRoles();

	return (
		<HelicopterContext.Provider
			value={{ enabled: enabled! && (isWorkspaceSuperuser || isManager), enable, disable }}
		>
			{props.children}
		</HelicopterContext.Provider>
	);
}

export function useHelicopter() {
	return useContext(HelicopterContext);
}
